export const capitalize = (text) =>
  `${text}`
    .trim()
    .toLowerCase()
    .replace(/^\w/, (c) => c.toUpperCase());

export const titleize = (text) => `${text}`.trim().split(' ').map(capitalize).join(' ');

export const normalize = (text) => `${text}`.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

export const queryParams = (url) => {
  const hashes = url.slice(url.indexOf('?') + 1).split('&');
  return hashes.reduce((params, hash) => {
    const [key, val] = hash.split('=');
    return Object.assign(params, { [key]: decodeURIComponent(val) });
  }, {});
};

export const currencyFormat = (amount, decimalCount = 2, decimal = ',', thousands = '.') => {
  try {
    decimalCount = Math.abs(decimalCount);
    decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

    const negativeSign = amount < 0 ? '-' : '';

    const i = parseInt((amount = Math.abs(Number(amount) || 0).toFixed(decimalCount))).toString();
    const j = i.length > 3 ? i.length % 3 : 0;

    return (
      negativeSign +
      (j ? i.substr(0, j) + thousands : '') +
      i.substr(j).replace(/(\d{3})(?=\d)/g, `$1${thousands}`) +
      (decimalCount
        ? decimal +
        Math.abs(amount - i)
          .toFixed(decimalCount)
          .slice(2)
        : '')
    );
  } catch (e) {
    console.log(e);
  }
};

export const firstLetterCase = (text) =>
  `${text.toLowerCase().slice(0, 1).toUpperCase()}${text.toLowerCase().slice(1)}`;

export const stripHtml = (html) => {
  if (!html) return '';

  const withSpaces = html.replace(/<\/?(p|br|li|ul|ol|div|h[1-6])[^>]*>/gi, ' ');
  const doc = new DOMParser().parseFromString(withSpaces, 'text/html');

  return (doc.body.textContent || '').replace(/\s+/g, ' ').trim();
};

export const formatMessage = (text) => {
  if (!text) return;

  let k = 0;
  const nextKey = () => k++;

  const applyInline = (str) => {
    const parts = [];
    const regex = /\*\*(.*?)\*\*|\*(.*?)\*/gs;
    let lastIndex = 0;
    let match;
    while ((match = regex.exec(str)) !== null) {
      if (match.index > lastIndex) parts.push(str.slice(lastIndex, match.index));
      if (match[1] !== undefined) parts.push(<strong key={nextKey()}>{match[1]}</strong>);
      else parts.push(<em key={nextKey()}>{match[2]}</em>);
      lastIndex = match.index + match[0].length;
    }
    if (lastIndex < str.length) parts.push(str.slice(lastIndex));
    return parts;
  };

  const normalized = text.replace(/--/g, '—');
  const lines = normalized.split('\n');
  const nodes = [];
  const listBuffer = [];

  const flushList = () => {
    if (listBuffer.length) {
      nodes.push(<ul key={nextKey()}>{listBuffer.splice(0)}</ul>);
    }
  };

  lines.forEach((line, i) => {
    if (line.startsWith('- ')) {
      listBuffer.push(<li key={i}>{applyInline(line.slice(2))}</li>);
    } else {
      flushList();
      if (nodes.length > 0) nodes.push(<p style={{ marginBottom: '10px' }} key={nextKey()} />);
      nodes.push(...applyInline(line));
    }
  });

  flushList();
  return nodes;
};

// j•••@example.com — enough for "is this my address?" without exposing it.
export const maskEmail = (email) => {
  const [local, domain] = `${email}`.split('@');
  if (!domain) return '•••';
  return `${local.charAt(0)}•••@${domain}`;
};
